import {useEffect} from 'react';
import CryptoJS from "crypto-js";

/**
 * cafe24 intro page
 * https://www.bizting.co.kr/hosting/cafe24/intro
 * */
const HostingCIntro = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const mallId = searchParams.get("mall_id");

    useEffect(() => {
        const state = {
            hostType: 'C',
            hostId: mallId
        }
        let encryptedState = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(state), process.env.REACT_APP_AES_ENCRYPT_KEY).toString());

        let url = `https://${mallId}.cafe24api.com/api/v2/oauth/authorize`
        url += `?response_type=code`
        url += `&client_id=${process.env.REACT_APP_CAFE24_CLIENT_ID}`
        url += `&redirect_uri=${process.env.REACT_APP_CAFE24_INTRO_REDIRECT_URI}`
        url += `&scope=${process.env.REACT_APP_CAFE24_SCOPE}`
        url += `&state=${encryptedState}`;

        window.location.href = url;
    }, [mallId]);
};

export default HostingCIntro;
